"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isElementInput = exports.checkExistInClassList = void 0;
var checkExistInClassList = function (item, classNames) {
    classNames.forEach(function (className) {
        expect(item.classList.contains(className)).toBe(true);
    });
};
exports.checkExistInClassList = checkExistInClassList;
var isElementInput = function (element) { return element instanceof HTMLInputElement; };
exports.isElementInput = isElementInput;
